import createAsyncSlice from "../utils/createAsyncSlice";
import { validateUserInformation } from "../utils/validateUserData";
import { getPopup } from "./popup";

const account = createAsyncSlice({
  name: "account",
  initialState: {
    data: null,
  },
});

export const fetchAccount = (data) => async (dispatch) => {
  try{
    const {payload} = await dispatch(account.asyncAction(data))
    validateUserInformation(payload)
    return true
  }catch (error){
    dispatch(getPopup({
      message: error.message,
      type: 'danger',
    }))
    return false
  }
};
export const httpRequestAccount = account.httpRequest;
export const { resetState: resetAccountState, getAccountById } =
  account.actions;
export default account.reducer;
